<template>
  <div>
    <div
      id="gallery_entrance"
      :class="[
        'gallery_entrance',
        'absolute',
        'w-full',
        'overflow-hidden',
        isEntered ? 'heightZero' : '',
      ]"
    >
      <img
        @click="isEntered = true"
        :class="[isEntered ? 'enterAni' : '']"
        src="../assets/images/gallery/gallery_entrance.jpg"
        alt="가상전시관입구"
      />
    </div>

    <div class="display_wrap absolute">
      <div class="relative w-full h-full" style="overflow-x: scroll">
        <div
          id="display_img_wrap"
          class="display_img_wrap absolute top-1/2 left-0 flex"
        >
          <div class="relative">
            <img src="../assets/images/gallery/wall1.png" alt="전시관 벽면1" />
            <ul class="first_wall">
              <li
                class="relative"
                v-for="(item, index) in galleryRelics.slice(0, 6)"
                :key="`relics_${index}`"
              >
                <div
                  v-if="item"
                  class="item_wrap absolute top-1/2 left-1/2"
                  @click.prevent.stop="onLink(item.usersRelics.relicsId)"
                >
                  <!-- <div
                  v-if="item"
                  class="item_wrap"
                  @click.prevent.stop="onRelicClick(item.usersRelics.relics)"
                > -->
                  <button
                    v-if="myGallery"
                    class="absolute top-2 right-0"
                    @click.prevent.stop="deleteGalleryRelic(item.id)"
                  >
                    <img
                      src="../assets/images/gallery/close.png"
                      alt="유물삭제"
                      class="w-8"
                    />
                  </button>
                  <img
                    class="relic"
                    :src="`${API_URL}${SERVICE_API_URL}/files/load/${item.usersRelics.relics.image}`"
                    :alt="item.usersRelics.relics.name"
                  />
                  <p class="absolute bottom-0 left-1/2 relic_name">
                    {{ item.usersRelics.relics.name }}
                  </p>
                </div>
                <div
                  v-if="!item && myGallery"
                  @click="
                    [
                      (showRelics = true),
                      (number = index + 1),
                      (showDescription = false),
                    ]
                  "
                  class="
                    show_relic_btn
                    z-10
                    absolute
                    top-1/2
                    left-1/2
                    p-2
                    rounded-full
                  "
                >
                  <p class="w-16">
                    <img
                      src="../assets/images/gallery/add.png"
                      alt="유물 등록"
                    />
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div class="relative">
            <img
              src="../assets/images/gallery/wall2-1.png"
              alt="전시관 벽면2"
            />
            <ul class="second_wall">
              <li
                class="relative"
                v-for="(item, index) in galleryRelics.slice(6, 8)"
                :key="`relics_${index}`"
              >
                <div
                  v-if="item"
                  class="item_wrap absolute top-1/2 left-1/2"
                  @click.prevent.stop="onLink(item.usersRelics.relicsId)"
                >
                  <!-- <div
                  v-if="item"
                  class="item_wrap"
                  @click.prevent.stop="onRelicClick(item.usersRelics.relics)"
                > -->
                  <button
                    v-if="myGallery"
                    class="absolute top-2 right-0"
                    @click.prevent.stop="deleteGalleryRelic(item.id)"
                  >
                    <img
                      src="../assets/images/gallery/close.png"
                      alt="유물삭제"
                      class="w-8"
                    />
                  </button>
                  <img
                    class="relic"
                    :src="`${API_URL}${SERVICE_API_URL}/files/load/${item.usersRelics.relics.image}`"
                    :alt="item.usersRelics.relics.name.ko"
                  />
                  <p class="absolute bottom-0 left-1/2 relic_name">
                    {{ item.usersRelics.relics.name }}
                  </p>
                </div>
                <div
                  v-if="!item && myGallery"
                  @click="
                    [
                      (showRelics = true),
                      (number = index + 7),
                      (showDescription = false),
                    ]
                  "
                  class="
                    show_relic_btn
                    z-10
                    absolute
                    top-1/2
                    left-1/2
                    rounded-full
                  "
                >
                  <p class="w-16">
                    <img
                      src="../assets/images/gallery/add.png"
                      alt="유물 등록"
                    />
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div class="relative">
            <img src="../assets/images/gallery/wall3.png" alt="전시관 벽면3" />
            <ul class="third_wall">
              <li
                class="relative"
                v-for="(item, index) in galleryRelics.slice(8, 12)"
                :key="`relics_${index}`"
              >
                <div
                  v-if="item"
                  class="item_wrap absolute top-1/2 left-1/2"
                  @click.prevent.stop="onLink(item.usersRelics.relicsId)"
                >
                  <!-- <div
                  v-if="item"
                  class="item_wrap"
                  @click.prevent.stop="onRelicClick(item.usersRelics.relics)"
                > -->
                  <button
                    v-if="myGallery"
                    class="absolute top-2 right-0"
                    @click.prevent.stop="deleteGalleryRelic(item.id)"
                  >
                    <img
                      src="../assets/images/gallery/close.png"
                      alt="유물삭제"
                      class="w-8"
                    />
                  </button>
                  <img
                    class="relic"
                    :src="`${API_URL}${SERVICE_API_URL}/files/load/${item.usersRelics.relics.image}`"
                    :alt="item.usersRelics.relics.name.ko"
                  />
                  <p class="absolute bottom-0 left-1/2 relic_name">
                    {{ item.usersRelics.relics.name }}
                  </p>
                </div>
                <div
                  v-if="!item && myGallery"
                  @click="
                    [
                      (showRelics = true),
                      (number = index + 9),
                      (showDescription = false),
                    ]
                  "
                  class="
                    show_relic_btn
                    z-10
                    absolute
                    top-1/2
                    left-1/2
                    rounded-full
                  "
                >
                  <p class="w-16">
                    <img
                      src="../assets/images/gallery/add.png"
                      alt="유물 등록"
                    />
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <gallery-relic-list
      v-if="showRelics"
      :items="myRelics"
      @handleClick="onClick"
      @close="showRelics = false"
    />
    <!-- 유물 설명 -->
    <div
      @click="[(showRelics = false), (showDescription = false)]"
      v-if="showDescription"
      class="
        desc
        absolute
        bottom-8
        left-1/2
        z-10
        text-center
        p-2
        pb-20
        text-gray-100
      "
    >
      <p class="text-xl py-2">{{ item.name }}</p>
      <div class="mt-1 text-md whitespace-pre-line">
        {{ item.essential }}
      </div>
    </div>
  </div>
</template>

<script>
import services from "../services";
import { API_URL, SERVICE_API_URL } from "../common/config";
import GalleryRelicList from "./GalleryRelicList.vue";
export default {
  name: "GalleryDisplay",
  components: { GalleryRelicList },
  props: {
    myGallery: {
      type: Boolean,
      default: true,
    },
    userId: {
      type: Number,
      default: 0,
    },
    galleryId: {
      type: Number,
      default: 0,
    },
    items: {
      type: Array,
      default: () => [],
    },
    myRelics: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showRelics: false,
      showDescription: false,
      clickedItem: 0,
      number: 0,
      galleryRelics: [],
      API_URL: "",
      SERVICE_API_URL: "",
      isEntered: false,
      item: {},
    };
  },

  created() {
    this.galleryRelics = this.items;
    this.API_URL = API_URL;
    this.SERVICE_API_URL = SERVICE_API_URL;
  },
  mounted() {
    if (!this.items.length) {
      console.log(this.items);
    }
  },
  methods: {
    onLink(id) {
      this.$router.push({ name: "AlbumId", params: { id: id } });
    },

    onClick(value) {
      this.clickedItem = value.item.id;
      const params = {
        galleriesId: this.galleryId,
        usersRelicsId: this.clickedItem,
        number: this.number,
      };
      services.regGalleryRelic(params).then(
        () => {
          // 새로고침
          this.fetch();
          this.showRelics = false;
        },
        (error) => {
          const { data } = error.response;
          console.log(data);
          alert("이미 전시관에 등록되었습니다");
        }
      );
    },

    async fetch() {
      services
        .galleryRelicFindByGalleryId({ galleriesId: this.galleryId, size: 1000 })
        .then(
          (response) => {
            const { data } = response;
            this.galleryRelics[0] = data.items.find((item) => item.number == 1);
            this.galleryRelics[1] = data.items.find((item) => item.number == 2);
            this.galleryRelics[2] = data.items.find((item) => item.number == 3);
            this.galleryRelics[3] = data.items.find((item) => item.number == 4);
            this.galleryRelics[4] = data.items.find((item) => item.number == 5);
            this.galleryRelics[5] = data.items.find((item) => item.number == 6);
            this.galleryRelics[6] = data.items.find((item) => item.number == 7);
            this.galleryRelics[7] = data.items.find((item) => item.number == 8);
            this.galleryRelics[8] = data.items.find((item) => item.number == 9);
            this.galleryRelics[9] = data.items.find(
              (item) => item.number == 10
            );
            this.galleryRelics[10] = data.items.find(
              (item) => item.number == 11
            );
            this.galleryRelics[11] = data.items.find(
              (item) => item.number == 12
            );

            console.log(this.galleryRelics);
            const parseString = require("xml2js").parseString;
            this.galleryRelics.forEach((item) => {
              if (item) {
                parseString(item.usersRelics.relics.name, (error, result) => {
                  if (result.lang) {
                    switch (this.$i18n.locale) {
                      case "ko":
                        item.usersRelics.relics.name = result.lang.ko[0];
                        break;
                      case "en":
                        item.usersRelics.relics.name = result.lang.en[0];
                        break;
                      case "child":
                        item.usersRelics.relics.name = result.lang.ko[0];
                        break;
                      case "zh":
                        item.usersRelics.relics.name = result.lang.zh[0];
                        break;
                      case "ja":
                        item.usersRelics.relics.name = result.lang.ja[0];
                        break;
                      default:
                        item.usersRelics.relics.name = result.lang.ko[0];
                    }
                    if (!item.usersRelics.relics.name) {
                      item.usersRelics.relics.name = result.lang.ko[0];
                    }
                  } else if (error) {
                    console.log(error);
                  }
                });
                parseString(
                  item.usersRelics.relics.essential,
                  (error, result) => {
                    if (result.lang) {
                      switch (this.$i18n.locale) {
                        case "ko":
                          item.usersRelics.relics.essential = result.lang.ko[0];
                          break;
                        case "en":
                          item.usersRelics.relics.essential = result.lang.en[0];
                          break;
                        case "child":
                          item.usersRelics.relics.essential =
                            result.lang.child[0];
                          break;
                        case "zh":
                          item.usersRelics.relics.essential = result.lang.zh[0];
                          break;
                        case "ja":
                          item.usersRelics.relics.essential = result.lang.ja[0];
                          break;
                        default:
                          item.usersRelics.relics.essential = result.lang.ko[0];
                      }
                      if (!item.usersRelics.relics.essential) {
                        item.usersRelics.relics.essential = result.lang.ko[0];
                      }
                    } else if (error) {
                      console.log(error);
                    }
                  }
                );
              }
            });
          },
          (error) => {
            const { data } = error.response;
            console.log(data);
          }
        );
    },

    deleteGalleryRelic(id) {
      services.deleteGalleryRelic(id).then(
        (response) => {
          const { data } = response;
          console.log(data);
          this.fetch();
          this.showRelics = false;
          this.showDescription = false;
        },
        (error) => {
          const { data } = error.response;
          console.log(data);
        }
      );
    },

    onRelicClick(item) {
      this.showDescription = true;
      this.showRelics = false;
      this.item = item;
    },
  },
};
</script>

<style>
.desc {
  width: 95%;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(4px);
  border-radius: 10px;
  height: 28vh;
  overflow: scroll;
  transform: translateX(-50%);
}

.display_wrap {
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
}

.display_img_wrap {
  height: 100%;
  transform: translateY(-50%);
  width: 1680px;
}
.display_img_wrap > div {
  height: 100%;
}
.display_img_wrap > div > img {
  height: 100%;
  display: inline-block;
  max-width: initial;
}
.display_wrap ul {
  height: 25%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-30%);
  display: flex;
  justify-content: space-between;
}

.display_wrap ul li {
  float: left;
  width: 90%;
  text-align: center;
  box-sizing: border-box;
}

.display_wrap ul li div {
  transform: translate(-50%, -50%);
}

.display_wrap ul li div .relic_name {
  transform: translateX(-50%);
  bottom: -25px;
  color: #fff;
  /* width: 100%; */
  text-shadow: 1px 1px 2px #000;
  white-space: nowrap;
  /* border: 1px solid red; */
}

.item_wrap {
  height: 90%;
  display: flex;
  /* align-items: flex-end; */
  align-items: center;
}

.item_wrap img.relic {
  max-height: 100%;
  margin: 0 auto;
}

/* first_wall */
.first_wall li:nth-child(2n-1) div {
  margin-left: 40px;
}

.first_wall li:nth-child(2n) div {
  margin-left: -40px;
}

.first_wall li button {
  right: -50px;
}

.first_wall .item_wrap {
  width: 35%;
}

/* second_wall */
.second_wall li:nth-child(1) div {
  margin-left: 60px;
}
.second_wall li:nth-child(2) div {
  margin-left: -60px;
}
.second_wall .item_wrap {
  width: 25%;
}
.second_wall li button {
  right: -140px;
}

/* third_wall */
.third_wall li button {
  right: -20px;
}

.third_wall li button {
  right: -80px;
}

/* 입장 애니메이션 */
.gallery_entrance {
  height: 100%;
  transition-delay: 1.5s;
  top: 0;
  left: 0;
  z-index: 11;
}
.gallery_entrance img {
  min-height: 100%;
}
.heightZero {
  transform: scaleY(0);
}
.enterAni {
  animation: fadeout ease 1.5s forwards;
}

@keyframes fadeout {
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: scale(2.5);
  }
}
</style>
